var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import { mapActions } from "vuex";
import VueDialog from "../../../interface/IVueDialog";
import BasicArcheivesService from '../../../api/BasicArcheivesService';
import CommonService from '../../../api/CommonService';
import AddGoods from "../../licenseManage/components/addGoodsCol2/AddGoods.vue";
import BusinessGoodsPriceService from "../../../api/BusinessGoodsPriceService";
import ThirdPartySystemService from '../../../api/ThirdPartySystemService';
import { Watch } from 'vue-property-decorator';
function setTreeData(treeData, id, name, disabledIds) {
    if (disabledIds === void 0) { disabledIds = []; }
    treeData.forEach(function (item) {
        item.id = item[id];
        item.name = item[name];
        if (disabledIds && disabledIds.length && disabledIds.includes(item[id])) {
            item.disabled = true;
        }
        if (item.children && item.children.length) {
            setTreeData(item.children, id, name, disabledIds);
        }
        ;
    });
}
var AddDialog = (function (_super) {
    __extends(AddDialog, _super);
    function AddDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cascader_props = {
            multiple: true,
            value: 'id',
            label: 'name',
            emitPath: false
        };
        _this.cascader_propswww = {
            multiple: true,
            value: 'id',
            label: 'name',
            emitPath: false
        };
        _this.type = 1;
        _this.organList = [];
        _this.depot = {
            rule_name: '',
            organ_id: '',
            depot_id: '',
            group_id: [],
            city_id: [],
            goods_type_id: [],
            goods_id: [],
            shop_id: '',
            from_system: 3,
            scm_delivery_depot_id: '',
            status: 1,
        };
        _this.ediStatus = 0;
        _this.supplierdepotOptions = [];
        _this.outStoreList = [];
        _this.areaList = [];
        _this.groupList = [];
        _this.shopList = [];
        _this.goods_type_id = [];
        _this.goods_count = 0;
        _this.refreshGoodsType = 0;
        _this.goodsRuleType = 1;
        _this.goodsRuleTypeOption = [
            {
                id: 1,
                name: '按货品类别',
            },
            {
                id: 2,
                name: '按货品',
            },
        ];
        _this.deliveryDepotOptions = [];
        return _this;
    }
    AddDialog.prototype.created = function () {
        var _this = this;
        this.service = BasicArcheivesService.getInstance();
        this.commonService = CommonService.getInstance();
        this.businessGoodsPriceService = BusinessGoodsPriceService.getInstance();
        this.thirdPartySystemService = ThirdPartySystemService.getInstance();
        if (this.storeEditInfo) {
            this.depot = {
                rule_name: this.storeEditInfo.rule_name || '',
                organ_id: this.storeEditInfo.organ_id || '',
                depot_id: this.storeEditInfo.depot_id || '',
                group_id: this.storeEditInfo.group_id || [],
                city_id: this.storeEditInfo.city_id || [],
                goods_type_id: this.storeEditInfo.goods_type_id,
                goods_id: this.storeEditInfo.goods_id || [],
                shop_id: this.storeEditInfo.shop_id,
                from_system: this.storeEditInfo.from_system,
                scm_delivery_depot_id: this.storeEditInfo.scm_delivery_depot_id,
                status: this.storeEditInfo.status,
            };
            this.goods_type_id = this.depot.goods_type_id;
            this.goods_count = this.depot.goods_id.length;
            if (this.depot.goods_id.length) {
                this.goodsRuleType = 2;
            }
        }
        if (!this.depot['organ_id']) {
            this.depot['organ_id'] = this.organList && this.organList.length && this.organList[0].organ_id;
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        Promise.all([
            this.getSupplierdepotOptions(),
            this.getGoodsType(),
            this.getArea(),
            this.getGroupNameList(),
        ]).then(function (result) {
            if (_this.ediStatus) {
                loadingInstance.close();
            }
            else {
                _this.getRuleShop({
                    init: 1
                }).then(function () {
                    loadingInstance.close();
                });
            }
        }).catch(function (error) {
            console.log(error);
        });
    };
    AddDialog.prototype.visibleChangeShop = function (type) {
        if (type === false) {
            this.getRuleShop();
        }
    };
    AddDialog.prototype.getDeliveryDepotOptions = function () {
        var _this = this;
        return this.thirdPartySystemService.getScmDeliveryDepots({
            depot_id: this.depot.depot_id
        }).then(function (res) {
            _this.deliveryDepotOptions = res.data.data;
        });
    };
    AddDialog.prototype.getSupplierdepotOptions = function () {
        var _this = this;
        var params = {
            organ_id: this.depot.organ_id,
            depot_id: this.depot.depot_id,
            is_init: 1
        };
        return this.commonService.getSupplierdepotOptions(params).then(function (res) {
            if (res.data.success) {
                if (!res.data.data || !res.data.data.length) {
                    _this.supplierdepotOptions = [];
                    return;
                }
                _this.supplierdepotOptions = res.data.data;
                if (!_this.depot.depot_id) {
                    (res.data.data || []).some(function (item) {
                        if (item.is_organ_default == 1) {
                            _this.depot.depot_id = item.depot_id;
                            return true;
                        }
                    });
                }
            }
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    AddDialog.prototype.dealDataForFlat = function (flatData) {
        var _this = this;
        return flatData.reduce(function (pre, cur) {
            return pre.concat(Array.isArray(cur.children) ? _this.dealDataForFlat(cur.children) : cur.id);
        }, []);
    };
    AddDialog.prototype.getGoodsType = function () {
        var _this = this;
        var param = { goods_type_id: '' };
        if (this.storeEditInfo) {
            param.goods_type_id = this.storeEditInfo.goods_type_id ? JSON.stringify(this.storeEditInfo.goods_type_id) : '';
        }
        return this.service.getGoodsType(Object.assign({
            level: 4,
        }, param)).then(function (res) {
            var data = res.data.data;
            if (!data || !data.length) {
                _this.outStoreList = [];
                return;
            }
            setTreeData(data, 'goods_type_id', 'goods_type_name', _this.extra_selected_goods_type);
            _this.outStoreList = data;
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    AddDialog.prototype.getArea = function () {
        var _this = this;
        return this.commonService.getArea().then(function (res) {
            var data = res.data;
            if (data.success) {
                data.data[0].name = "全部城市";
                _this.areaList = [data.data[0]];
                if (!_this.storeEditInfo) {
                    _this.depot.city_id = _this.dealDataForFlat(_this.areaList);
                }
            }
            else {
                _this.$message.error(data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    AddDialog.prototype.getGroupNameList = function () {
        var _this = this;
        return this.commonService.getGroupNameList().then(function (res) {
            var data = res.data;
            if (data.success) {
                if (!data.data || !data.data.length) {
                    _this.groupList = [];
                    return;
                }
                setTreeData(data.data, 'value', 'name');
                var treeData = data.data;
                treeData[0].name = "全部客户";
                var dtreeData = [treeData[0]];
                dtreeData[0]['children'] = treeData.slice(1);
                _this.groupList = dtreeData;
                if (!_this.storeEditInfo) {
                    _this.depot.group_id = _this.dealDataForFlat(_this.groupList);
                }
                else {
                    var groups = _this.storeEditInfo.group_id;
                    if (groups.indexOf(-1) != -1) {
                        _this.depot.group_id = _this.dealDataForFlat(_this.groupList);
                    }
                }
            }
            else {
                _this.$message.error(data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    AddDialog.prototype.getRuleShop = function (params) {
        var _this = this;
        var CheckedNodes = this.$refs.region.getCheckedNodes();
        if (CheckedNodes && !CheckedNodes[0].parent) {
            this.depot.city_id.push('86000000');
        }
        return this.commonService.getRuleShop({
            group_id: JSON.stringify(this.depot.group_id),
            city_id: JSON.stringify(this.depot.city_id),
        }).then(function (res) {
            var data = res.data;
            if (data.success) {
                if (!data.data || !data.data.length) {
                    _this.shopList = [];
                    return;
                }
                setTreeData(data.data, 'shop_id', 'shop_name');
                var treeData = data.data;
                treeData[0].name = "全部门店";
                var dtreeData = [treeData[0]];
                dtreeData[0]['children'] = treeData.slice(1);
                _this.shopList = dtreeData;
                if (params && params.init) {
                    if (!_this.storeEditInfo) {
                        _this.depot.shop_id = _this.dealDataForFlat(_this.shopList);
                    }
                    else {
                        var shops = _this.storeEditInfo.shop_id;
                        if (shops.indexOf(-1) != -1) {
                            _this.depot.shop_id = _this.dealDataForFlat(_this.shopList);
                        }
                    }
                }
                else {
                    _this.depot.shop_id = _this.dealDataForFlat(_this.shopList);
                }
            }
            else {
                _this.$message.error(data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    AddDialog.prototype.changeOrganId = function (rec) {
        this.depot.depot_id = '';
        this.getSupplierdepotOptions();
    };
    AddDialog.prototype.getFilterData = function () {
        var _this = this;
        if (!this.ediStatus) {
            return Promise.resolve();
        }
        if (this.depot.depot_id && this.depot.scm_delivery_depot_id) {
            return this.service.getStoreSplitFilterData({
                rule_id: this.storeEditInfo ? this.storeEditInfo.rule_id : null,
                from_system: this.depot.from_system,
                depot_id: this.depot.depot_id,
                scm_delivery_depot_id: this.depot.scm_delivery_depot_id,
            }).then(function (res) {
                if (res.data && res.data.data) {
                    _this.extra_selected_goods = res.data.data.extra_selected_goods;
                    _this.extra_selected_goods_type = res.data.data.extra_selected_goods_type;
                    _this.depot.goods_id = [];
                    _this.goods_count = 0;
                    _this.depot.goods_type_id = [];
                    _this.getGoodsType();
                    return res.data;
                }
                return res;
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
                return Promise.reject(err);
            });
        }
        return Promise.resolve();
    };
    AddDialog.prototype.mounted = function () {
    };
    AddDialog.prototype.depotIdChange = function (newVal) {
        if (this.ediStatus) {
            if (newVal) {
                this.getDeliveryDepotOptions();
            }
            else {
                this.depot.scm_delivery_depot_id = '';
                this.deliveryDepotOptions = [];
            }
        }
    };
    AddDialog.prototype.extraSelectedGoodsTypeChange = function () {
        this.refreshGoodsType++;
        this.getGoodsType();
    };
    AddDialog.prototype.close = function () {
        this.$closeDialog();
    };
    AddDialog.prototype.submitData = function () {
        if (!this.depot.rule_name) {
            this.$message.error("请输入规则名称");
            return;
        }
        ;
        if (!this.depot.organ_id) {
            this.$message.error("请选择所属机构");
            return;
        }
        ;
        if (!this.depot.depot_id) {
            this.$message.error("请选择所属仓库");
            return;
        }
        ;
        if (this.ediStatus) {
            if (!this.depot.scm_delivery_depot_id) {
                this.$message.error("请选择对应库存仓库");
                return;
            }
        }
        else {
            if (!this.depot.group_id.length) {
                this.$message.error("请选择客户分组");
                return;
            }
            ;
            if (!this.depot.city_id.length) {
                this.$message.error("请选择城市");
                return;
            }
            ;
            if (!this.depot.shop_id.length) {
                this.$message.error("请选择门店");
                return;
            }
            ;
        }
        if (this.goodsRuleType === 1 && !this.depot.goods_type_id.length) {
            this.$message.error("请选择货品类型");
            return;
        }
        if (this.goodsRuleType === 2 && !this.depot.goods_id.length) {
            this.$message.error("请选择货品");
            return;
        }
        if (this.shopList[0] && this.depot.shop_id.length === this.shopList[0].children.length) {
            this.depot.shop_id.push(-1);
        }
        if (this.groupList[0] && this.depot.group_id.length === this.groupList[0].children.length) {
            this.depot.group_id.push(-1);
        }
        var params = {
            type: this.type,
            rule_name: this.depot.rule_name,
            organ_id: this.depot.organ_id,
            depot_id: this.depot.depot_id,
            shop_id: JSON.stringify(this.depot.shop_id),
            scm_delivery_depot_id: this.depot.scm_delivery_depot_id,
            group_id: JSON.stringify(this.depot.group_id),
            goods_type_id: JSON.stringify(this.depot.goods_type_id),
            goods_id: JSON.stringify(this.depot.goods_id),
            city_id: JSON.stringify(this.depot.city_id),
            from_system: this.depot.from_system
        };
        if (this.storeEditInfo) {
            var data = {
                rule_id: this.storeEditInfo.rule_id
            };
            Object.assign(data, params);
            this.updateStore(data);
        }
        else {
            this.addStore(params);
        }
    };
    AddDialog.prototype.addStore = function (params) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var promiseFn = this.service.addStoreSplit;
        if (this.ruleName === 'SpotPurchase') {
            promiseFn = this.service.addStoreSpotPurchase;
        }
        promiseFn(params).then(function (res) {
            if (res.data.success) {
                _this.$message.success('保存成功！');
                _this.$closeDialog();
                _this.$emit('addClient:ok', {
                    depot_id: res.data.data,
                    organ_id: _this.depot.organ_id
                });
            }
            else {
                var msg = res.data.msg.length > 200 ? res.data.msg.slice(0, 200) + '...' : res.data.msg;
                _this.$message.error({
                    message: msg,
                    duration: 2000
                });
            }
            ;
            loadingInstance.close();
        }).catch(function (err) {
            var msg = err.message.length > 200 ? err.message.slice(0, 200) + '...' : err.message;
            _this.$message.error({
                message: msg,
                duration: 2000
            });
            loadingInstance.close();
        });
    };
    AddDialog.prototype.updateStore = function (params) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var promiseFn = this.service.updateStoreSplit;
        if (this.ruleName === 'SpotPurchase') {
            promiseFn = this.service.updateStoreSpotPurchase;
        }
        promiseFn(params).then(function (res) {
            loadingInstance.close();
            if (res.data.success) {
                _this.$message.success('修改成功！');
                _this.$closeDialog();
                _this.$emit('addClient:ok');
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    AddDialog.prototype.bindGoods = function (row) {
        return __awaiter(this, void 0, void 0, function () {
            var loadingInstance, addedDatas, extra_selected_goods, dialog;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        loadingInstance = Loading.service({ fullscreen: true });
                        return [4, this.getSelectedGoods()];
                    case 1:
                        addedDatas = _a.sent();
                        loadingInstance.close();
                        extra_selected_goods = this.extra_selected_goods;
                        dialog = this.$dialog(AddGoods, {
                            data: {
                                addedDatas: addedDatas,
                                tabTableComponent: 'license-bind-goods-tab-table',
                                showSelected: true,
                                extra_selected_goods: extra_selected_goods
                            }
                        }, {
                            title: "绑定货品",
                            width: 950,
                            height: 500
                        });
                        dialog.instance.$on("save:ok", function (res) {
                            if (res.length == 0) {
                                _this.$message.warning('请至少选择一个货品');
                                return;
                            }
                            _this.goods_count = res.length;
                            _this.depot.goods_id = res.map(function (v) { return v.goods_id; });
                            dialog.instance.close();
                        });
                        return [2];
                }
            });
        });
    };
    AddDialog.prototype.getTypeGoodsCount = function (res) {
        var afterGoodsByType = {};
        for (var i = 0; i < res.length; i++) {
            var goods = res[i];
            var typeId = goods.goods_type_id;
            if (afterGoodsByType[typeId]) {
                afterGoodsByType[typeId] += 1;
            }
            else {
                afterGoodsByType[typeId] = 1;
            }
        }
        return afterGoodsByType;
    };
    AddDialog.prototype.getSelectedGoods = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, selectedData;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.depot.goods_id.length === 0) {
                            return [2, []];
                        }
                        params = {
                            dimension: 1,
                            in_goods_id: this.depot.goods_id.join(','),
                            limit: 10000,
                        };
                        selectedData = [];
                        return [4, this.businessGoodsPriceService.getGoodslist(Object.assign({}, params)).then(function (res) {
                                if (res.data.success) {
                                    selectedData = res.data.data;
                                }
                            }, function (err) {
                                _this.$message.error(err.message);
                            }).catch(function (err) {
                                _this.$message.error(err.msg || err.message);
                            })];
                    case 1:
                        _a.sent();
                        return [2, selectedData];
                }
            });
        });
    };
    AddDialog.prototype.changeGoodsRuleTypeOption = function () {
        if (this.goodsRuleType === 1) {
            this.depot.goods_id = [];
        }
        else {
            this.depot.goods_type_id = [];
        }
    };
    AddDialog.prototype.goodsTypeChange = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var loadingInstance, addedElements, deletedElements, addedGoodsIds, deletedGoodsIds;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        loadingInstance = Loading.service({ fullscreen: true });
                        addedElements = this.depot.goods_type_id.filter(function (value) { return _this.goods_type_id.indexOf(value) === -1; });
                        deletedElements = this.goods_type_id.filter(function (value) { return _this.depot.goods_type_id.indexOf(value) === -1; });
                        this.goods_type_id = this.depot.goods_type_id;
                        return [4, this.getGoodsIdsByTypes(addedElements)];
                    case 1:
                        addedGoodsIds = _a.sent();
                        return [4, this.getGoodsIdsByTypes(deletedElements)];
                    case 2:
                        deletedGoodsIds = _a.sent();
                        this.depot.goods_id = Array.from(new Set(this.depot.goods_id.concat(addedGoodsIds)));
                        this.depot.goods_id = this.depot.goods_id.filter(function (value) { return deletedGoodsIds.indexOf(value) === -1; });
                        this.goods_count = this.depot.goods_id.length;
                        loadingInstance.close();
                        return [2];
                }
            });
        });
    };
    AddDialog.prototype.getGoodsIdsByTypes = function (type_ids) {
        return __awaiter(this, void 0, void 0, function () {
            var selectedData, params;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (type_ids.length === 0) {
                            return [2, []];
                        }
                        selectedData = [];
                        params = {
                            dimension: 1,
                            goods_type: type_ids.join(','),
                            limit: 10000,
                        };
                        return [4, this.businessGoodsPriceService.getGoodslist(Object.assign({}, params)).then(function (res) {
                                if (res.data.success) {
                                    selectedData = res.data.data;
                                }
                            }, function (err) {
                                _this.$message.error(err.message);
                            }).catch(function (err) {
                                _this.$message.error(err.msg || err.message);
                            })];
                    case 1:
                        _a.sent();
                        return [2, selectedData.map(function (v) { return v.goods_id; })];
                }
            });
        });
    };
    __decorate([
        Watch("depot.depot_id", { deep: true })
    ], AddDialog.prototype, "depotIdChange", null);
    __decorate([
        Watch("extra_selected_goods_type")
    ], AddDialog.prototype, "extraSelectedGoodsTypeChange", null);
    AddDialog = __decorate([
        Component({
            methods: __assign({}, mapActions(["getAuth"]))
        })
    ], AddDialog);
    return AddDialog;
}(VueDialog));
export default AddDialog;
